export default __webpack_public_path__ + "static/media/Leap Forward Logo.7e4e28aa.png";